import { render, staticRenderFns } from "./CollateralFolderMenu.vue?vue&type=template&id=64931a45&scoped=true&"
import script from "./CollateralFolderMenu.vue?vue&type=script&lang=js&"
export * from "./CollateralFolderMenu.vue?vue&type=script&lang=js&"
import style0 from "./CollateralFolderMenu.vue?vue&type=style&index=0&id=64931a45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64931a45",
  null
  
)

export default component.exports